import { cn } from "@volca/ui/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-md bg-neutral", className)}
      {...props}
    />
  )
}

export { Skeleton }
